import { useDataValue } from 'Simple/Data.js'
import View from './view.js'

export default function Logic(props) {
  let notes = useDataValue({
    context: 'notes',
    viewPath: props.viewPath,
  })

  let allCount = notes.length

  return <View {...props} allCount={allCount} />
}
